export enum SECTION_IDS {
  FINDER_PROMO = "finder-promo",
  TOOLS = "finder-tools",
  FINDER_DEMO = "finder-demo",
  FOOTER = "footer"
}
